export default __webpack_public_path__ + "static/media/redcross.3c662b75.png";